import { Refresh } from "@mui/icons-material";
import LoadingButton from '@mui/lab/LoadingButton';
import { FC } from "react";
import { useTranslation } from "react-i18next";

const CustomLoadMore: FC<{ count: number, setCount: (count: number) => void, loading: boolean }> = (props) => {
    const { count, setCount, loading } = props;
    const { t } = useTranslation();
    return <LoadingButton
        loading={loading}
        loadingPosition="start"
        startIcon={<Refresh />}
        variant="outlined"
        color="secondary"
        onClick={() => setCount(count + 1)}
        sx={{ mt: 2 }}
    >
        {t("lists.loadMore")}
    </LoadingButton>
}

export default CustomLoadMore;